export default __webpack_public_path__ + "static/media/creative_team.07c2b071.mp4";